<script lang="ts" setup>
import { useI18n } from "vue-i18n";

import type { BillingMethodEnum } from "@/api/billing/dto/invoice";

const { t } = useI18n();

const props = defineProps<{
  paymentType: BillingMethodEnum;
}>();
</script>

<template>
  <span class="text-grey-darken-1" data-qa="invoice-billing-method">
    {{ t(`billing.payment-types.${props.paymentType}`) }}
  </span>
</template>
